import FirstRow from "./1st-row"
import SecondRow from "./2nd-row"
import ThirdRow from "./3th-row"

export default function Contact (props) {
  return (
    <div className="contact">
      <FirstRow />
      <SecondRow />
      <ThirdRow />
    </div>
  )
}